export default "<p>\n  base-layout works!\n</p>\n"